const { READ_ONLY_FEATURES } = process.env;

const crudConfig = {
    endpoint: 'securityschemes',
    primaryKey: 'schemeId',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'core',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'core',
            args: ['schemeId']
            // query: {
            //     expand: 'CriteriaResourceParamDTO'
            // }
        }
    },
    metadata: {
        endpoint: 'core/securitypermissions',
        functions: {
            fetch: {
                method: 'get',
                returnType: 'Object',
                service: 'core',
                args: [],
                query: {}
            }
        }
    }
};

if (!READ_ONLY_FEATURES || READ_ONLY_FEATURES === 'false') {
    crudConfig.functions = {
        ...crudConfig.functions,
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'core'
            // args: ['nodeId', 'nodeDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'core'
            // args: ['nodeId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'core'
            // args: ['nodeDoc']
        }
    };
}

export default crudConfig;
